import React from "react";
import { Link } from "react-router-dom";
import { renderStarIcon } from "../../../../_helper";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import ProgressBarComponent from "../../../../Components/UI/ProgressBarComponent";
const SingleMyCourseCard = ({ Course, ...props }) => {
  let {
    course_id,
    client_progress_percentage,
    course_image,
    course_lessons,
    client_progress,
    selection_date,
    can_display,
    course_rating,
    course_duration,
  } = Course || {};

  const { lang } = useSelector((state) => state?.UI); //ar or en
  const completedPercentage =
    ((client_progress / (course_lessons || 1)) * 100) / 100;

  return (
    <div className="card">
      <div className="card-body">
        <div className="media">
          <div className="media-left">
            <Link to={`/partners/courses/${course_id}`}>
              <img
                src={course_image || "/public/imgs/courseIcon_3.png"}
                alt={Course[`course_name_${lang}`]}
                width="100"
                className="rounded"
              />
            </Link>
          </div>
          <div className="media-body">
            <h4 className="card-title hero__lead m-0">
              <Link
                to={`/partners/courses/${course_id}`}
                className="!tw-text-primary hover:!tw-text-primaryLight"
              >
                {Course[`course_name_${lang}`]}
              </Link>
            </h4>

            <span className="text-muted tw-text-[15px] tw-inline-block tw-mt-2">
              Enrolled At :{" "}
              {moment(selection_date).format("MMMM Do YYYY, h:mm:ss a")}
            </span>
            <span className="text-muted tw-text-[15px] tw-inline-block tw-mt-2">
              Course Duration : {course_duration}
            </span>
          </div>
        </div>
        <ProgressBarComponent progress={client_progress_percentage} />
      </div>

      <div className="card-footer tw-flex bg-white justify-content-between">
        <div className="rating my-auto">
          {[...Array(5)].map((_, index) => (
            <i key={index} className="material-icons">
              {renderStarIcon(index, course_rating)}
            </i>
          ))}
        </div>
        <div className="d-flex justify-content-end">
          {completedPercentage === 0 && (
            <>
              {can_display ? (
                <Link
                  to={`/partners/courses/${course_id}`}
                  className="btn btn-primary btn-sm ml-2 px-4 !tw-w-32"
                >
                  Start{" "}
                  <i className="material-icons btn__icon--right">
                    play_circle_outline
                  </i>{" "}
                </Link>
              ) : (
                "Not Available Content"
              )}
            </>
          )}
          {client_progress / (course_lessons || 1) > 0 &&
            client_progress / (course_lessons || 1) < 1 && (
              <>
                <Link
                  to={`/partners/courses/${course_id}`}
                  className="btn btn-primary btn-sm ml-2 px-4 !tw-w-32"
                >
                  Continue{" "}
                  <i className="material-icons btn__icon--right">
                    play_circle_outline
                  </i>
                </Link>
              </>
            )}
          {client_progress / (course_lessons || 1) === 1 && (
            <>
              <Link
                to={`/partners/courses/${course_id}`}
                className="btn btn-primary btn-sm !tw-w-32"
              >
                Completed{" "}
                <i className="material-icons btn__icon--right">check</i>
              </Link>
              {/* <Link
                to={`/partners/courses/${course_id}`}
                className="btn btn-white btn-sm ml-2"
              >
                Restart{" "}
                <i className="material-icons btn__icon--right">replay</i>{" "}
              </Link> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleMyCourseCard;
